<template>
  <div class="verifications-page">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'verifications-page',
}
</script>
